import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import BgImg from "../../images/services-usa/b2b-portal/whychooseportal.webp";

function Whychooseecommerce() {
  return (
    <section
      className="trusted_ecommerce_web ecommerce_why_choose text_white p-100"
      style={{
        backgroundImage: `url(${BgImg})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <Container>
        <Row>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
            <h2>
              Why Choose TekRevol as Your <span>B2B Portal Development</span>{" "}
              Company?
            </h2>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
            <p>
              At TekRevol, we engineer modern, secure, and high-performance B2B
              portals that solve complex business challenges. Our B2B portal
              development services empower companies to streamline operations,
              enhance security, and achieve exceptional efficiency through
              state-of-the-art technology and customized solutions.
            </p>
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
            <Row className="mt-3 mt-md-5">
              <Col xs={12} md={6} lg={6} xl={4} xxl={4} className="mb-4">
                <div className="trusted_ecomm_box">
                  <div className="ecomm_title">01</div>
                  <div className="ecomm_box_content">
                    <h5>Rapid Market Evolution</h5>
                    <p>
                      We build flexible portals that adapt swiftly to evolving
                      business needs and technological advancements without
                      operational disruptions occurring.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={6} xl={4} xxl={4} className="mb-4">
                <div className="trusted_ecomm_box">
                  <div className="ecomm_title">02</div>
                  <div className="ecomm_box_content">
                    <h5>Complex System Integration</h5>
                    <p>
                      Our portals seamlessly integrate with existing enterprise
                      systems, ensuring interoperability, data consistency, and
                      efficient workflows across your organization.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={6} xl={4} xxl={4} className="mb-4">
                <div className="trusted_ecomm_box">
                  <div className="ecomm_title">03</div>
                  <div className="ecomm_box_content">
                    <h5>Security Threats & Vulnerabilities</h5>
                    <p>
                      We implement advanced security protocols to protect
                      sensitive data against cyber threats, unauthorized access,
                      and data breaches at all levels.
                    </p>
                  </div>
                </div>
              </Col>
              <Col
                xs={12}
                md={6}
                lg={6}
                xl={4}
                xxl={4}
                className="mb-xl-0 mb-4"
              >
                <div className="trusted_ecomm_box">
                  <div className="ecomm_title">04</div>
                  <div className="ecomm_box_content">
                    <h5>Inefficient Business Processes</h5>
                    <p>
                      We automate workflows to streamline operations, reduce
                      manual effort, increase productivity, and eliminate
                      inefficiencies in your processes effectively.
                    </p>
                  </div>
                </div>
              </Col>
              <Col
                xs={12}
                md={6}
                lg={6}
                xl={4}
                xxl={4}
                className="mb-md-0 mb-4"
              >
                <div className="trusted_ecomm_box">
                  <div className="ecomm_title">05</div>
                  <div className="ecomm_box_content">
                    <h5>Subpar User Experience</h5>
                    <p>
                      Our user-centric designs enhance usability, leading to
                      higher engagement, satisfaction, and adoption among all
                      stakeholders and users effectively.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
                <div className="trusted_ecomm_box">
                  <div className="ecomm_title">06</div>
                  <div className="ecomm_box_content">
                    <h5>Scalability Limitations</h5>
                    <p>
                      We develop scalable architectures that support growing
                      business demands without compromising system performance
                      or user experience quality ever.
                    </p>
                  </div>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Whychooseecommerce;
